import { Alert, Heading, IconButton, Pane, RefreshIcon, Spinner } from 'evergreen-ui';
import { useMemo, useState } from 'react';

import DataTable from '../../common/DataTable/DataTable';
import { getOrderColumns } from '../../orders/components/orderColumns';
import { useListOrdersWithIssuesQuery } from '../../../v2/features/threads/threads.api';
import { TicketsModal, useTicketsModal } from '../../../v2/features/tickets/components/EntityTickets';

const LIMIT = 10;

function OrdersWithIssues() {
  const [page, setPage] = useState(1);
  const tickets = useTicketsModal();

  const { data, isLoading, isFetching, isError, refetch } = useListOrdersWithIssuesQuery(
    { page, limit: LIMIT },
    { pollingInterval: 60000 }
  );

  const orders = data?.orders ?? [];
  const pagination = data?.pagination ?? { page, limit: LIMIT, totalCount: 0, totalPages: 0 };

  const columns = useMemo(() => {
    const c = getOrderColumns({ onOpenThreads: tickets.open, withPreview: true });
    return [c.issue, c.orderNumber, c.tags, c.customer, c.status, c.payment, c.delivery, c.grandTotal, c.issuesCount, c.createdAt];
  }, [tickets.open]);

  const handleTableChange = (opts) => {
    const nextPage = Math.floor((opts.start || 0) / LIMIT) + 1;
    setPage(nextPage);
  };

  return (
    <Pane>
      <Pane display="flex" alignItems="center" justifyContent="space-between" marginBottom={16}>
        <Heading size={600}>
          Probleme ({pagination.totalCount})
        </Heading>
        <IconButton icon={RefreshIcon} onClick={() => refetch()} disabled={isFetching} />
      </Pane>

      {isLoading && (
        <Pane display="flex" alignItems="center" justifyContent="center" padding={40}>
          <Spinner />
        </Pane>
      )}

      {isError && !isLoading && (
        <Pane padding={16}>
          <Alert intent="danger" title="Eroare">
            Nu am putut încărca lista comenzilor cu tickete deschise.
          </Alert>
        </Pane>
      )}

      {!isLoading && !isError && orders.length === 0 && (
        <Pane padding={16}>
          <Alert intent="success" title="Totul e în regulă">
            Nicio comandă cu tickete deschise.
          </Alert>
        </Pane>
      )}

      {!isLoading && !isError && orders.length > 0 && (
        <DataTable
          columns={columns}
          data={orders}
          updateKey={orders}
          page={pagination.page}
          pageSize={LIMIT}
          pageCount={pagination.totalPages}
          onTableChange={handleTableChange}
          paginationMode="paged"
          search={false}
          filters={false}
          height="auto"
        />
      )}

      <TicketsModal target={tickets.target} onClose={tickets.close} />
    </Pane>
  );
}

export default OrdersWithIssues;
